import { createContext, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCurrentDateDDMMYYYY } from "./utils/getCurrentDate";
import {
  addNewDocTransmittal,
  getAllDocTransmittalsProject,
  getProject,
} from "./api";
const date = getCurrentDateDDMMYYYY();

export const DocTransmittalContext = createContext();
export const useDocTransmittalContext = () => useContext(DocTransmittalContext);

export const AuthContextProvider = ({ children }) => {
  const { id: projectId } = useParams();

  const initialState = {
    number: "",
    rev: 0,
    receiver: { id: "", name: "", email: "" },
    receiverType: "Client",

    project: { id: projectId },
    date,
  };

  const [allDocTransmittals, setAllDocTransmittals] = useState([]);
  const [newDoc, setNewDoc] = useState(initialState);
  const [files, setFiles] = useState([]);
  const [tab, setTab] = useState("Clients");

  useEffect(() => {
    if (!newDoc?.project?.name) {
      const func = async () => {
        const res = await getProject({ projectId });
        setNewDoc({ ...newDoc, project: { ...res } });
      };
      func();
    }

    const getDocTransmittals = async () => {
      const res = await getAllDocTransmittalsProject({ projectId });
      setAllDocTransmittals(res);
    };
    getDocTransmittals();
  }, []);

  const handleChangeTab = (_, newValue) => {
    setTab(newValue);
  };
  const onCLickAddNew = () => {
    setTab("form");
  };

  const onCLickAddNewRev = ({ row }) => {
    setTab("form");
    console.log("row", row);
  };

  const onSubmit = async () => {
    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append("docs", files[i]);
    }

    formData.append("data", JSON.stringify(newDoc));

    const res = await addNewDocTransmittal(formData);
    console.log("After saving doc transmittal:", res);
    return res;
  };

  return (
    <DocTransmittalContext.Provider
      value={{
        newDoc,
        setNewDoc,
        files,
        setFiles,

        allDocTransmittals,

        tab,
        handleChangeTab,
        onCLickAddNew,
        onCLickAddNewRev,

        onSubmit,
      }}
    >
      {children}
    </DocTransmittalContext.Provider>
  );
};
